import React, { Component } from 'react';
import styled from 'styled-components/macro';

import { Td, Tr } from '../../../components/Table';
import { Checkbox } from '../../../components/Forms';
import { Money } from '../../../components/Formatters';
import { LineItem, Order } from '../../../types/orders';

export interface CaptureItemProps {
    item: LineItem;
    checked: boolean;
    order: Order;
    onChange: (lineId: number) => void;
}

class AuthorizeItemRow extends Component<CaptureItemProps> {
    constructor(props: CaptureItemProps, context: any) {
        super(props, context);
        this.toggleItem = this.toggleItem.bind(this);
    }

    toggleItem = () => {
        const { item, onChange } = this.props;
        onChange(item.line_id || -1);
    };

    render() {
        const { item, order, checked } = this.props;

        const getClickableCellClassName = (className: string, disabled: boolean) => {
            if (disabled) {
                return className;
            }
            return `${className} interactive`;
        };

        return (
            <ItemTr key={item.line_id}>
                <ItemTd className="checkbox">
                    <Checkbox
                        name={`${item.line_id || -1}`}
                        label={null}
                        checked={checked}
                        onChange={this.toggleItem}
                    />
                </ItemTd>
                <ItemTd className={getClickableCellClassName('id', false)} onClick={this.toggleItem}>
                    {item.line_id}
                </ItemTd>
                <ItemTd className={getClickableCellClassName('description', false)} onClick={this.toggleItem}>
                    {item.description}
                </ItemTd>
                <ItemTd className={getClickableCellClassName('details', false)} onClick={this.toggleItem}>
                    {item.description_alias}
                </ItemTd>
                <ItemTd className="quantity" onClick={this.toggleItem}>
                    {item.quantity || 0}
                </ItemTd>
                <ItemTd className="amount" onClick={this.toggleItem}>
                    <Money amount={item.net_amount || 0} currency={order.currency} />
                </ItemTd>
            </ItemTr>
        );
    }
}

export default AuthorizeItemRow;

const ItemTd = styled(Td)`
    &.amount {
        width: 10%;
    }
    &.quantity {
        width: 15%;
    }
    &.description {
        width: 25%;
        user-select: none;
    }
    &.details {
        width: 30%;
        user-select: none;
    }
    &.id {
        width: 15%;
        user-select: none;
    }
    &.checkbox {
        width: 5%;
    }
    &.interactive {
        cursor: pointer;
    }
`;

const ItemTr = styled(Tr)``;
